<app-date-picker
	label="Agreement Date"
	[ngModel]="agreementDate$ | async"
	(ngModelChange)="onChange($event)"
	orientation="row"
	(focus)="_onFocus()"
	[maxDate]="closingDate$ | async"
	[skeletonLoading]="skeletonLoading"
	maxDateErrorLabel="Closing Date"
	[testHook]="testHooks.AgreementDateDatePicker"
	[labelIcon]="AI_ICON"
	[labelToolTip]="(agreementDateMappings$ | async) ? AI_TOOLTIP : ''"
	[labelIconClasses]="AI_CLASSES"
/>
